import { shortVideoSets } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function ShortVideoSets() {
  return (
    <section
      id="sets"
      className="bg-background-100 px-6 lg:px-10 py-14 md:py-20 border-y border-background-200 scroll-mt-24"
    >
      <SectionHeading
        index="04"
        label="Short Video Sets"
        title="短视频合集"
        desc="单条时长短、可以连着看的片段集合，适合通勤、做饭或者当背景声音的时候随手打开。"
      />

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {shortVideoSets.map((set) => (
          <a
            key={set.name}
            href="#hot"
            className="group rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors overflow-hidden cursor-pointer"
          >
            <div className="relative w-full h-44 bg-background-200 overflow-hidden">
              <img
                src={set.cover}
                alt={`${set.name}合集封面`}
                title={`蘑菇视频 短视频合集 ${set.name}`}
                className="w-full h-full object-top"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/95 text-foreground-900 text-xs flex items-center gap-1">
                <i className="ri-film-line text-accent-600"></i>
                {set.count} 条
              </span>
            </div>
            <div className="p-4">
              <h5 className="font-heading font-bold text-[16px] text-foreground-950">
                {set.name}
              </h5>
              <p className="mt-1.5 text-sm text-foreground-600">{set.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary-600">
                打开合集
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}